<div>
    <div class="row mb-2">
        <div class="col pl-0">
            <div widget class="card border-0 box-shadow">
                <div class="card-header transparent  text-muted">
                    <div class="row">
                        <div class="col-lg-8">
                            <h4 class="mb-0 font-header">Add Admin Time</h4>
                        </div>
                    </div>
                </div>
                <div class="card-body  widget-body pb-0 pt-2 mb-4">
                    <!-- Employee Name -->
                    <div class="row">
                        <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                            <label class="font-header"> Employee Name <sup class="super-script">
                                    *</sup></label>
                            <ng-select [searchable]="true" [clearable]="true" [(ngModel)]="EditEmployeeId" id="AdminTimeEditEmployeeId"
                                [items]="EditATInputProperty.EmployeeDropDown" bindLabel="Value" bindValue="Key">
                            </ng-select>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                            <label class="font-header">Entry Type</label>
                            <ng-select [searchable]="true" [clearable]="true" [(ngModel)]="EditEntryTypeLid" id="AdminTimeEntrytypeId"
                                [items]="EditATInputProperty.EditEntryTypeList" bindLabel="lovName" bindValue="id">
                            </ng-select>
                        </div>
                    </div>
                    <hr>
                    <!-- Client,Service,Date,Hours -->
                    <div class="row d-none d-lg-flex">
                        <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
                            <label class="manualentry-label">Date<sup class="super-script"> *</sup></label>
                        </div>
                        <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
                            <label class="manualentry-label">In<sup class="super-script"> *</sup></label>
                        </div>
                        <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
                            <label class="manualentry-label">Out<sup class="super-script"> *</sup></label>
                        </div>
                        <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
                            <label class="manualentry-label">Hours<sup class="super-script"> *</sup></label>
                        </div>
                        <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
                            <label class="manualentry-label">Notes</label>
                        </div>
                       
                    </div>
                    <div class="row  ">
                        <!-- Date -->
                        <div class="col-lg-2 col-md-3 col-sm-12 col-xs-12">
                            <my-date-picker [options]="myDatePickerOptions" [selDate]="EditDate" id="AdminTimeEditDate"
                                placeholder="mm/dd/yyyy" (inputFieldChanged)="DateChanges($event,'inputchanged','Date')"
                                (dateChanged)="DateChanges($event,'datechanged','Date')">
                            </my-date-picker>
                        </div>
                        <!-- In -->
                        <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
                            <input type="time" class="form-control" [(ngModel)]="EditIn" [disabled]="EditDate==null ||
                            EditDate==undefined || EditDate==''" (ngModelChange)="HoursCalculation()" id="AdminTimeEditIn">
                        </div>
                        <!-- Out -->
                        <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
                            <input type="time" class="form-control" [(ngModel)]="EditOut" [disabled]="EditDate==null ||
                            EditDate==undefined || EditDate==''" (ngModelChange)="HoursCalculation()" id="AdminTimeEditOut">
                        </div>
                        
                        <!-- Hours -->
                        <div class="col-lg-2 col-md-3 col-sm-12 col-xs-12 ">
                            <input type="text" disabled class="form-control" [(ngModel)]="EditTotalHours" id="AdminTimeEditTotalHours">
                        </div>
                         <!-- Notes -->
                         <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 d-inline-flex">
                            <textarea type="time" class="form-control" [(ngModel)]="EditNotes" id="AdminTimeEditNotes">
                            </textarea>
                            <button class="btn btn-sm blue-btn mt-0 mb-2 ms-1" style="height: 27px;" (click)="AddAtItems()" [disabled]="EditTotalHours==null ||
                            EditTotalHours==''|| EditTotalHours==undefined ||
                             EditEmployeeId=='00000000-0000-0000-0000-000000000000'||  EditEmployeeId==undefined ||  EditEmployeeId==null||
                            EditDate==null || EditDate==undefined || EditDate=='' ||
                            EditIn=='' || EditIn==null || EditIn==undefined ||
                            EditOut=='' || EditOut==undefined || EditOut==null " id="AdminTimeAddAtItems">
                                Add
                            </button>
                        </div>
                       
                        <div class="col-lg-2 col-md-6 col-sm-12 col-xs-12">
                        </div>
                    </div>
                    <!-- Table -->
                    <div class="table-responsive" *ngIf="ATEditDetails.length>0">
                        <table class="table table-hover table-bordered mt-3 ">
                            <thead>
                                <th class="pointer" class="text-center" style="color:white;background-color:  #00786a">
                                    Employee
                                </th>
                                <th class="pointer" class="text-center" style="color:white;background-color:  #00786a">
                                    In
                                </th>
                                <th class="pointer" class="text-center" style="color:white;background-color:  #00786a">
                                    Out
                                </th>
                                <th class="pointer" class="text-center" style="color:white;background-color:  #00786a">
                                    Date
                                </th>
                                <th class="pointer" class="text-center" style="color:white;background-color:  #00786a">
                                    Total Hours
                                </th>
                                <th class="pointer" class="text-center" style="color:white;background-color:  #00786a">
                                  Notes
                                </th>
                                <th class="pointer" class="text-center" style="color:white;background-color:  #00786a">
                                    Entry Type
                                  </th>
                                <th class="pointer" class="text-center" style="color:white;background-color:  white">
                                </th>
                            </thead>
                            <tbody class="manualtablescroll ">
                                <tr *ngFor="let ATList of ATEditDetails;let Ats=index">
                                    <td class="text-center" tabindex="-1" style="color:black">
                                        {{ATList.employeeName }}
                                    </td>
                                    <td class="text-center" tabindex="-1">
                                        {{ATList.setIn | date:'shortTime'}}
                                    </td>
                                    <td class="text-center" tabindex="-1">
                                        {{ATList.setOut | date:'shortTime'}}
                                    </td>
                                    <td class="text-center" tabindex="-1">
                                        {{ATList.date}}
                                    </td>
                                    <td class="text-center" tabindex="-1" >
                                        {{ATList.totalhours}}
                                    </td>
                                    <td class="text-center" tabindex="-1" >                                       
                                        <i class="fa fa-eye" title="view notes" (click)="viewnotes = ATList.notes" data-bs-target="#shownotes" data-bs-toggle="modal"></i>
                                    </td>
                                    <td class="text-center" tabindex="-1" >
                                        {{ATList.entryTypeName}}
                                    </td>
                                    <td class="text-center" tabindex="-1">
                                        <i class="fa fa-minus-circle ms-2 text-danger" (click)="removeATList(Ats)"
                                            style="font-size: 22px;"></i>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <!-- Save &  Close -->
                    <div class="row mt-5">
                        <div class="col-lg-6"></div>
                        <div class="col-lg-6 text-end">
                            <button class="btn btn-sm blue-btn" (click)="promiseCallFunction()" id="AdminTimepromiseCallFunction"
                                [disabled]="ATEditDetails.length==0">
                                <span>Save & Close</span>
                            </button>&nbsp;&nbsp;
                            <button class="btn btn-sm blue-btn" (click)="closeAT()" id="AdminTimecloseAT">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<span id="OpenNotesModal" data-bs-target="#shownotes" data-bs-toggle="modal"></span>
<div class="modal fade" id="shownotes" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true">

    <div class="modal-dialog " role="document">
        <div class="modal-content">
            <div class="modal-header">
                <label class="font-header">Notes</label>

                <button type="button" class="btn-close" data-bs-dismiss="modal" id="viewnotes"></button>
            </div>
            <div class="modal-body">
                <div class="container scrolltbody">
                    <div class="col-lg-12">
                        {{viewnotes}}
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm" data-bs-dismiss="modal" data-bs-target="#modal" id="ATListUpdateAdminTimeNotesbtn">Close</button>
            </div>
        </div>
    </div>
</div>